import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import Loader from "components/loader/Loader";
import { tripEnumObject } from "utils/enumObject";
import { truncateComment } from "utils/utils";
import { debounce, set } from "lodash";
import location from "assets/images/location.svg";
import "./CommonAutoComplete.scss";
import { getLocationCheck,getClearLocationCheck } from "redux/actions/UserGoogleMap";

function CommonAutoComplete(props) {
  const dispatch = useDispatch();
  const token = props?.token;
  const type = props?.type;
  const [isDisabled, setIsDisabled] = useState(true);
  const [selectedValue, setSelectedValue] = useState({});
  const [openDateTimePicker, setOpenDateTimePicker] = useState(false);
  const [pickup, setPickup] = useState({});
  const [drop, setDrop] = useState({});
  const [optionData, setOptionData] = useState(props?.optionData || []);
  const [airportData, setAirportData] = useState(
    props?.airportOptionData || props?.timeSlabData || []
  );
  const [date, setDate] = useState(
    props?.defaultTripValues["date"] && props?.defaultTripValues["date"]
  );
  const [endDate, setEndDate] = useState(
    props?.defaultTripValues["endDate"] && props?.defaultTripValues["endDate"]
  );
  const [dropValue, setDropValue] = useState(null);

  const currentDate = new Date();
  const bufferDateTime = (second) => {
    setDate(
      dayjs(
        currentDate.setMinutes(
          Math.ceil(currentDate.getMinutes() / 10) * 10 + second / 60
        )
      )
    );
    setValue(
      "date",
      dayjs(
        currentDate.setMinutes(
          Math.ceil(currentDate.getMinutes() / 10) * 10 + second / 60
        )
      )
    );

    setEndDate(
      dayjs(
        currentDate.setMinutes(
          Math.ceil(currentDate.getMinutes() / 10) * 10 + 3600 / 60
        )
      )
    );
    setValue(
      "endDate",
      dayjs(
        currentDate.setMinutes(
          Math.ceil(currentDate.getMinutes() / 10) * 10 + 3600 / 60
        )
      )
    );
  };
  const locationResponse = useSelector(
    (state) => state.userLocationCheck?.userLocationCheck
  );

  useEffect(() => {
    setOptionData(props?.optionData);
  }, [props?.optionData]);
  useEffect(() => {
    setAirportData(props?.airportOptionData || props?.timeSlabData);
  }, [props?.airportOptionData, props?.timeSlabData]);
  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    control,
    formState: { isValid, errors },
  } = useForm({ defaultValues: props?.defaultTripValues, mode: "onChange" });

  useEffect(() => {
    if (props?.pageType === "commonRideTab") {
      if (props?.defaultTripValues?.["pickup"]?.address_components) {
        setValue("pickup", props?.defaultTripValues?.["pickup"]);
        setPickup(props?.defaultTripValues?.["pickup"]);
      }
    } else if (props?.pageType === "homeForm") {
      setDate(dayjs(props?.defaultTripValues?.["date"]?.$d));
      setEndDate(dayjs(props?.defaultTripValues?.["endDate"]?.$d));
    }
    if (props?.defaultTripValues?.package) {
      setSelectedValue(props?.defaultTripValues);
    }
  }, [props?.defaultTripValues]);

  useEffect(() => {
    if (type) {
      bufferDateTime(
        props?.timeSlabData?.bookingBuffer ||
          props?.timeSlabData ||
          props?.bufferTime ||
          600
      );
    }
  }, [
    type,
    props?.timeSlabData?.bookingBuffer,
    props?.timeSlabData,
    props?.bufferTime,
  ]);

  const handleInput = (e, value) => {
    const rentalObject = optionData?.filter(
      (item) => item.id === e.target.value
    )[0];
    sessionStorage.setItem("package", JSON.stringify(rentalObject));
    if (pickup) {
      setIsDisabled(false);
    }
    clearErrors(e.target.name);
    let data = {};
    if (value && value !== undefined) {
      data[e.target.name] = value;
    } else {
      data[e.target.name] = e.target.value;
    }
    if (rentalObject) {
      setSelectedValue(rentalObject);
    }
    props?.handleInput(e, value);
  };
  const onInputChangeVal = debounce((event, value, name) => {
    if (value?.length < 1) {
      sessionStorage.removeItem(name);
    }
    if (event?.type === "change" && value?.length) {
      props?.onInputChangeVal(event, value, name);
    }
  }, 300);

  useEffect(() => {
    if (pickup?.place_id && drop?.place_id && date?.$d) {
      if (
        (type === tripEnumObject.outStationRound && endDate?.$d) ||
        type !== tripEnumObject.outStationRound
      ) {
        setIsDisabled(false);
      }
    }
  }, [pickup?.place_id, drop?.place_id, date?.$d, endDate?.$d]);

  useEffect(() => {
    if(type === tripEnumObject.outStationRound) {
    if (locationResponse.success) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }}
  }, [locationResponse,date?.$d, endDate?.$d]); 

  const getOptionLabel = (option) => {
    if (option?.description) {
      return option?.description;
    } else if (option?.formatted_address) {
      return option?.formatted_address;
    } else if (option?.vicinity) {
      return option?.name + "," + option?.vicinity;
    } else {
      return "";
    }
  };

  const optionsData = (name) => {
    if (name === "pickup" || type == tripEnumObject?.outStationRound) {
      return props?.locationData;
    } else if (name === "drop") {
      return props?.nearbySearchData;
    }
  };

  const setValueSession = (name, value) => {
    setValue(name, value);
    sessionStorage.setItem(name, JSON.stringify(value));
  };
  const onHandleChange = (event, value, name) => {
    clearErrors(event.target.name);
    dispatch(getClearLocationCheck());
    if (props?.onHandleChange && token) {
      props?.onHandleChange(event, value, name);
    } else if (
      props?.onHandleChange &&
      (props?.type === tripEnumObject?.rental ||
        props?.type === tripEnumObject?.airport ||
        !token)
    ) {
      props?.onHandleChange(event, value, name);
      if (name === "pickup") {
        setPickup(value);
        setValueSession(name, value);
      } else if (name === "drop") {
        if (props?.type === tripEnumObject?.outStationRound) {
          const payload = {
            sourceAddress: pickup?.description,
            destinationAddress: value?.description,
            type: props?.type,
            location: "",
          };
          dispatch(getLocationCheck(payload));
        }
        setDrop(value);
        setValueSession(name, value);
      } else if (name === "date") {
        setDate(value);
        setValue(name, value);
      }
    }
  };
  const onChangeDate = (e, name) => {
    if (!isNaN(e?.$D) && name === "date") {
      setDate(dayjs(e));
      props?.onChangeDate(e, name);
    }
    if (!isNaN(e?.$D) && name === "endDate") {
      setEndDate(dayjs(e));
      props?.onChangeDate(e, name);
    }
  };
  const handleOpen = (fieldName) => {
    setOpenDateTimePicker(fieldName);
  };
  const handleClose = () => {
    setOpenDateTimePicker(null);
  };
  const handleOverlayClick = (fieldName) => {
    handleOpen(fieldName);
  };
  const onCurrentAddress = () => {
    props?.onCurrentAddress();
  };

  const onSubmit = (data, code) => {
    let dataVal = data;
    if (token) {
      sessionStorage.setItem("pickup", JSON.stringify(pickup));
      sessionStorage.setItem("drop", JSON.stringify(drop));
    } else if (pickup && drop) {
      sessionStorage.setItem(
        "pickup",
        JSON.stringify(
          pickup?.description ? pickup : props?.defaultTripValues?.pickup
        )
      );
      sessionStorage.setItem("drop", JSON.stringify(drop));
      const date = data?.date?.$d;
      sessionStorage.setItem("date", date.toISOString());
    }
    props?.onSubmitBtn(dataVal, code);
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container>
          {props?.formData?.length > 0 &&
            props?.formData?.map((ele, idx) => (
              <Grid item xs={12} key={idx}>
                <FormControl variant="standard" className="width100">
                  {ele?.autoComplete ? (
                    <Stack xs={12}>
                      {props?.currentLoader && ele?.name === "pickup" ? (
                        <CircularProgress color="inherit" />
                      ) : (
                        <Autocomplete
                          id="free-solo-demo"
                          disableClearable
                          freeSolo
                          defaultValue={
                            props?.defaultTripValues[ele?.name]
                              ? props?.defaultTripValues[ele?.name]
                              : null
                          }
                          getOptionLabel={(option) => getOptionLabel(option)}
                          options={optionsData(ele?.name) || []}
                          disabled={ele?.disabled || false}
                          onChange={(event, value) => {
                            setValue(ele?.name, value);
                            onHandleChange(event, value, ele?.name);
                          }}
                          onInputChange={(e, value) =>
                            onInputChangeVal(e, value, ele?.name)
                          }
                          renderOption={(props, option) => (
                            <li {...props}>
                              <Grid
                                container
                                className="spacingLeft"
                                spacing={1}
                              >
                                <Grid item className="displayNone">
                                  <img src={location} alt="location" />
                                </Grid>
                                <Grid item justifyContent="start">
                                  <Typography className="font14 fontNormal">
                                    {truncateComment(
                                      option?.name
                                        ? option?.name
                                        : option?.structured_formatting
                                            ?.main_text,
                                      50
                                    )}
                                  </Typography>
                                  <Typography className="font12 colorGrey">
                                    <Tooltip
                                      title={option?.description}
                                      placement="bottom"
                                    >
                                      {truncateComment(
                                        option?.vicinity
                                          ? option?.name +
                                              "," +
                                              option?.vicinity
                                          : option?.description,
                                        50
                                      )}
                                    </Tooltip>
                                  </Typography>
                                </Grid>
                              </Grid>
                            </li>
                          )}
                          renderInput={(params) => (
                            <Box className="dflex">
                              <div
                                className={ele?.border ? "pickup" : null}
                              ></div>
                              <img
                                className="wh33 marginRight10"
                                src={ele?.image}
                                alt="pickupicon"
                              />
                              {params.InputProps.startAdornment}
                              <TextField
                                {...params}
                                margin="normal"
                                className="inputStyle"
                                placeholder={ele?.placeholder}
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      {ele?.icon ? (
                                        <img
                                          src={ele?.icon}
                                          alt="location"
                                          onClick={() => onCurrentAddress()}
                                          className="cursor"
                                        />
                                      ) : null}
                                    </InputAdornment>
                                  ),
                                }}
                                {...register(ele?.name, {
                                  required: true,
                                })}
                              />
                            </Box>
                          )}
                        />
                      )}

                      {errors[ele?.name] && (
                        <Grid item>
                          <Typography className="errorMessages">
                            This field is required.
                          </Typography>
                        </Grid>
                      )}
                    </Stack>
                  ) : ele?.type === "options" ? (
                    <FormControl>
                      <Box className="marginBlock10 dflex alignItem">
                        <img
                          src={ele?.image}
                          alt="pickupicon"
                          className="marginRight10 wh33"
                        />
                        <Box className="width100">
                          <Select
                            value={
                              props?.defaultTripValues?.package?.id ||
                              props?.rentalPackage
                            }
                            className="inputStyle width100"
                            IconComponent={(params) => (
                              <ExpandMoreRoundedIcon
                                className="marginRight10"
                                {...params}
                              />
                            )}
                            // renderValue={(selected) => {
                            //   if (selected?.length === 0) {
                            //     return <em>{ele?.placeholder}</em>;
                            //   }
                            //   else{
                            //     return selected
                            //   }
                            // }}
                            disabled={props?.disabled || ele?.disabled}
                            {...register(ele?.name, {
                              required: ele?.required || false,
                            })}
                            onChange={(e) => handleInput(e)}
                            displayEmpty
                            inputProps={{
                              "aria-label": "Without label",
                            }}
                          >
                            {optionData?.map((option) => (
                              <MenuItem key={option.id} value={option.id}>
                                {option?.label}
                              </MenuItem>
                            ))}
                          </Select>
                          {errors[ele?.name] && (
                            <Typography className="colorRed">
                              This field is required.
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </FormControl>
                  ) : ele?.type === "date" ? (
                    <Grid item container className="marginBlock10">
                      <Grid item xs={12}>
                        <Box className="alignItem">
                          <img
                            src={ele?.image}
                            alt="pickupicon"
                            className="marginRight16 wh24"
                          />
                          <Controller
                            name={ele?.name}
                            control={control}
                            rules={{ required: "Date is required" }}
                            render={({ field }) => (
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <div className="dateTimePickerContainer">
                                  <DateTimePicker
                                    {...field}
                                    views={[
                                      "year",
                                      "month",
                                      "day",
                                      "hours",
                                      "minutes",
                                    ]}
                                    open={openDateTimePicker === field.name}
                                    onOpen={() => handleOpen(field.name)}
                                    onClose={() => handleClose()}
                                    minutesStep={2}
                                    skipDisabled={true}
                                    ampm={false}
                                    value={
                                      ele?.name === "date" ? date : endDate
                                    }
                                    disabled={ele?.disabled || false}
                                    onChange={(e) => {
                                      setValue(ele?.name, e);
                                      onChangeDate(e, ele?.name);
                                    }}
                                    defaultValue={dayjs(date) || null}
                                    className="inputStyle width100"
                                    minDateTime={dayjs().add(
                                      props?.timeSlabData || props?.bufferTime,
                                      "second"
                                    )}
                                    format="D/MM/YYYY h:mm A"
                                    slotProps={{
                                      textField: {
                                        placeholder:
                                          ele?.name === "date"
                                            ? "Start Date & Time"
                                            : "Return Date & Time",
                                      },
                                    }}
                                  />
                                  <div
                                    className="clickableOverlay"
                                    onClick={() =>
                                      handleOverlayClick(ele?.name)
                                    }
                                  ></div>
                                </div>
                              </LocalizationProvider>
                            )}
                          />
                        </Box>
                      </Grid>
                      {errors[`date`] && !date && (
                        <Typography className="errorMessages">
                          {errors[`date`].message}
                        </Typography>
                      )}
                    </Grid>
                  ) : ele?.singleAutoComplete ? (
                    <Stack xs={12}>
                      <Autocomplete
                        id="free-solo-demo"
                        disableClearable
                        defaultValue={
                          props?.defaultTripValues[ele?.name]
                            ? props?.defaultTripValues[ele?.name]
                            : ""
                        }
                        getOptionLabel={(option) =>
                          option.label || option.name || ""
                        }
                        options={airportData}
                        onChange={(event, value) =>
                          onHandleChange(event, value, ele?.name)
                        }
                        onInputChange={(e, value) =>
                          onInputChangeVal(e, value, ele?.name)
                        }
                        filterSelectedOptions
                        renderOption={(props, option) => (
                          <li {...props}>
                            <Grid
                              container
                              className="spacingLeft"
                              key={option?.id}
                            >
                              <Grid item>
                                <img src={location} alt="location" />
                              </Grid>
                              <Grid
                                item
                                justifyContent="start"
                                className="marginLeft16 width375"
                              >
                                <Typography className="font14 fontNormal">
                                  {option?.label || option?.name}
                                </Typography>
                              </Grid>
                            </Grid>
                          </li>
                        )}
                        renderInput={(params) => (
                          <Box className="dflex">
                            <div
                              className={ele?.border ? "pickup" : null}
                            ></div>
                            <img
                              className="wh33 marginRight10"
                              src={ele?.image}
                              alt="pickupicon"
                            />
                            {params.InputProps.startAdornment}
                            <TextField
                              {...params}
                              margin="normal"
                              className="inputStyle"
                              placeholder={ele?.placeholder}
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: "disabled", // disable autocomplete and autofill
                              }}
                              {...register(ele?.name, {
                                required: true,
                              })}
                            />
                          </Box>
                        )}
                      />
                      {errors[ele?.name] && (
                        <Typography className="errorMessages">
                          This field is required.
                        </Typography>
                      )}
                    </Stack>
                  ) : null}
                </FormControl>
              </Grid>
            ))}
        </Grid>

        {props?.btnEnable === true || !props?.token ? (
          <Grid item md={12} className="alignTextCenter">
            <Button
              variant="contained"
              size="medium"
              type="submit"
              className={`buttonEnabled 
              ${isDisabled ? "buttonDisabled" : ""}
              `}
              disabled={isDisabled}
            >
              {props.loading ? <Loader /> : "Book a cab"}
            </Button>
          </Grid>
        ) : null}
      </form>
    </div>
  );
}
export default CommonAutoComplete;